import axios from "axios";
import { ref, computed } from "vue";
const runningCount = ref(0);
const isClientBusy = computed(() => runningCount.value > 0);
const CreateClient = () => {
    const _client = axios.create({
        headers: {
            "x-requested-with": "XMLHttpRequest"
        }
    });
    _client.interceptors.request.use(config => {
        runningCount.value++;
        const tempPass = window.GetTempPassValue?.();
        if (tempPass) {
            config.headers['anypromo-t-pass'] = tempPass;
        }
        return config;
    });
    _client.interceptors.response.use(response => {
        runningCount.value--;
        return response;
    }, error => {
        runningCount.value--;
        return Promise.reject(error);
    });
    return _client;
};
const defaultHttpClient = CreateClient();
export { defaultHttpClient, isClientBusy, CreateClient };
